import React, { useState, useCallback, useEffect, useRef } from "react";
import {
  Input,
  TextArea,
  Form,
  Menu,
  Icon,
  Button,
  Loader,
  Header,
  Modal,
  Radio,
  Checkbox,
  Segment,
} from "semantic-ui-react";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import * as yup from "yup";

import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";

import Informacoes from "../../../../components/Admin/Empresas/Editar/Informacoes";
import Gerentes from "../../../../components/Admin/Empresas/Editar/Gerentes";
import Planos from "../../../../components/Admin/Empresas/Editar/Planos";

import swal from "sweetalert";

import {
  Container,
  Title,
  Content,
  Field,
  Label,
  InputFile,
  InputText,
  InputLabel,
} from "./styled";

import { isAuthAdmin } from "../../../../services/auth";
import { producaov2 as api } from "../../../../services/apis";
import { systemLogs } from "../../../../services/system_logs";
import { AlignDiv } from "../criarEmpresas/styled";

const EditarEmpresas = (req) => {
  const [valorName, setValorName] = useState("Informacoes");
  const [gerentes, setGerentes] = useState([]);
  const [gerentesCriar, setGerentesCriar] = useState([]);
  const [gerentesDel, setGerentesDel] = useState([]);
  const [gestores, setGestores] = useState([]);
  const [planosCriar, setPlanosCriar] = useState([]);
  const [planosEdit, setPlanosEdit] = useState([]);
  const [planosDel, setPlanosDel] = useState([]);
  const [planos, setPlanos] = useState([]);
  const [curso, setCurso] = useState([]);
  const [empresa, setEmpresa] = useState({});
  const [loading, setLoading] = useState(true);
  const logo = useRef({ valor: "" });
  const id = req.match.params.id;

  useEffect(() => {
    loadAuth();
    loadEmpresa();
    loadCursos();
    loadGerentes();
    loadPlanos();
  }, []);

  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/empresas`);
      window.location.href = "/login";
      return null;
    }
  };

  const loadEmpresa = useCallback(async () => {
    api
      .get(`/admin/empresas/${id}`)
      .then((res) => {
        setEmpresa(res.data);
      })
      .catch((err) => {
        swal(
          "ops!, Ocorreu um erro durante o recebimento das informações",
          err,
          "error"
        );
      });
  }, [id]);

  const loadCursos = () => {
    api
      .get("/cursos-ids")
      .then((res) => {
        const stateOptions = res.data.map((curso) => ({
          text: `[${curso.id}] - ${curso.curso}`,
          value: curso.id,
        }));
        setCurso((curso) => [...curso, ...stateOptions]);
      })
      .catch((err) => {
        swal("Ops!, Ocorreu um erro", err, "error");
      });
  };

  const loadGerentes = useCallback(() => {
    const params = {
      id_empresa: id,
    };

    api
      .get(`/admin/empresa/gestor`, {
        params,
      })
      .then((res) => {
        setGerentes(res.data);
      })
      .catch((err) => {
        swal(
          "ops!, Ocorreu um erro durante o recebimento das informações",
          err,
          "error"
        );
      });
  }, [id]);

  const loadPlanos = useCallback(async () => {
    await api
      .get(`/planos/empresa/${id}`)
      .then((res) => {
        setPlanos(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  }, [id]);

  const uploadImage = async (imagem) => {
    setEmpresa((empresa) => ({ ...empresa, file: imagem }));
    const imageData = new FormData();

    imageData.append("file", imagem);
    imageData.append("path", "imagens-voitto/imagens-blog/meta/ctas");

    try {
      const response = await api.post("/upload", imageData);
      swal("Imagem enviada com sucesso", "", "success");
      logo.current["valor"] = response.data.url;
      return response.data.url;
    } catch (err) {
      swal("Ops!, Ocorreu um erro durante o envio da imagem", "", "error");
      return "";
    }
  };

  const handleInfo = async (newEmpresa) => {
    if (!newEmpresa.file && !newEmpresa.logo) {
      setEmpresa((empresa) => ({
        ...empresa,
        nome: newEmpresa.nome,
        url: newEmpresa.url,
        logo: null,
      }));

      return;
    }

    const fileLogo = await uploadImage(newEmpresa.file);
    setEmpresa((empresa) => ({
      ...empresa,
      nome: newEmpresa.nome,
      url: newEmpresa.url,
      file: newEmpresa.file,
      logo: fileLogo,
    }));
  };
  const handlePlanos = (props) => {
    setPlanos(props);
  };
  const handlePlanosCriar = (props) => {
    setPlanosCriar(props);
  };
  const handlePlanosEdit = (props) => {
    setPlanosEdit(props);
  };
  const handlePlanosDel = (props) => {
    setPlanosDel(props);
  };
  const handleGerentes = (props) => {
    setGerentes(props);
  };
  const handleGerentesCriar = (props) => {
    setGerentesCriar(props);
  };

  const handleGerentesDel = (props) => {
    setGerentesDel(props);
  };

  const handleCortesia = async () => {
    const payload = {
      id: id,
    };
    try {
      await api
        .post(`/empresas/${id}/cortesias`, payload)
        .then((res) => {
          swal("Cortesias enviada com sucesso", "", "success");
        })
        .catch((err) => {
          swal("Não foi possível enviar a cortesia", err, "");
        });
    } catch {
      swal("Não foi possível enviar a cortesia", "", "");
    }
  };

  const handleEmpresa = async () => {
    const empresaValidation = yup.object().shape({
      nome: yup
        .string("Necessário que informe o nome da empresa")
        .required("Necessário que informe o nome da empresa"),
      logo: yup
        .string("Necessário que envie a logo do empresa")
        .required("Necessário que envie a logo do empresa"),
      url: yup
        .string("Necessário que informe url do portal da empresa")
        .required("Necessário que informe url do portal da empresa"),
    });

    try {
      await empresaValidation.validate(empresa, { abortEarly: true });

      await api
        .put(`/empresas/${id}`, empresa)
        .then((res) => {
          let array = {
            local: "empresas",
            texto: `editou a empresa de id=${id}`,
          };
          api.post("system_logs", { acao: JSON.stringify(array) });
          swal("Empresa modificada com sucesso", "", "success");
        })
        .catch((err) => {
          swal("Não foi possível modificar a empresa", err, "");
        });

      if (planosCriar.length != 0) {
        await Promise.all(
          planosCriar.map((plano) => {
            return api
              .post(`/admin/plano/empresa/`, {
                empresa: id,
                curso: plano.curso,
                bolsas: plano.bolsas,
                acesso: plano.acesso,
              })
              .then((res) => {
                let array = {
                  local: "empresas",
                  texto: `criou um plano da empresa de id=${id}`,
                };
                api.post("system_logs", { acao: JSON.stringify(array) });
              })
              .catch((err) => {
                swal("Não foi possível criar planos da empresa", err, "");
              });
          })
        );

        setPlanosCriar([]);
      }
      if (planosEdit.length != 0) {
        await Promise.all(
          planosEdit.map((plano) => {
            return api
              .put(`/admin/plano/empresa/${plano.id}`, {
                empresa: plano.empresa,
                curso: plano.curso,
                bolsas: plano.bolsas,
                acesso: plano.acesso,
              })
              .then((res) => {
                systemLogs("empresas", `editou o plano da empresa de id=${id}`);
              })
              .catch((err) => {
                console.error(err);
                swal(
                  "Não foi possível editar os planos da empresa",
                  "erro",
                  ""
                );
              });
          })
        );

        setPlanosEdit([]);
      }
      if (planosDel.length != 0) {
        await Promise.all(
          planosDel.map((plano) => {
            return api
              .delete(`/admin/plano/empresa/${plano.id}`)
              .then((res) => {
                systemLogs(
                  "empresas",
                  `deletou o plano da empresa de id=${id}`
                );
              })
              .catch((err) => {
                console.error(err);
                swal(
                  "Não foi possível deletar os planos da empresa",
                  "erro",
                  ""
                );
              });
          })
        );

        setPlanosDel([]);
      }
      if (gerentesCriar.length != 0) {
        await Promise.all(
          gerentesCriar.map((gerente) => {
            return api
              .post(`/admin/empresa/gestor`, {
                id_pessoa: gerente.id,
                id_empresa: id,
              })
              .then((res) => {
                systemLogs(
                  "empresas",
                  `adicionou a pessoa id=${gerente.id} como gerente da empresa ${id}`
                );
              })
              .catch((err) => {
                console.error(err);
                swal(
                  "Erro !",
                  "Não foi possível adicionar o gerente a empresa",
                  "error"
                );
              });
          })
        );

        setGerentesCriar([]);
      }
      if (gerentesDel.length != 0) {
        await Promise.all(
          gerentesDel.map((gerente) => {
            return api
              .delete(`/admin/empresa/gestor/${gerente.id}`)
              .then((res) => {
                systemLogs(
                  "empresas",
                  `adicionou a pessoa id=${gerente.id_pessoa} como gerente da empresa ${id}`
                );
              })
              .catch((err) => {
                console.error(err);
                swal(
                  "Erro !",
                  "Não foi possível adicionar o gerente a empresa",
                  "error"
                );
              });
          })
        );

        setGerentesDel([]);
      }
    } catch (err) {
      if (err instanceof yup.ValidationError) {
        swal("Erro!", `${err}`, "error");
        return;
      }
    }
  };

  return (
    <>
      <Container>
      <AdminMenu />
        <Content>
        {loading ? (
          <Loader active inline="centered" size="massive" />
        ) : (
          <>
            <Title>Editar Empresa</Title>

            <Menu pointing>
              <Menu.Item
                name="Informacoes"
                active={valorName === "Informacoes"}
                onClick={(e) => setValorName(e.target.text)}
              />
              <Menu.Item
                name="Planos"
                active={valorName === "Planos"}
                onClick={(e) => setValorName(e.target.text)}
              />
              <Menu.Item
                name="Gerentes"
                active={valorName === "Gerentes"}
                onClick={(e) => setValorName(e.target.text)}
              />
              <Menu.Menu position="right">
                <AlignDiv>
                  <h3>Criação de {valorName}</h3>
                </AlignDiv>
              </Menu.Menu>
            </Menu>

            <Segment>
              <div>
                {
                  {
                    Informacoes: (
                      <Informacoes handleInfo={handleInfo} valor={empresa} />
                    ),
                    Planos: (
                      <Planos
                        handlePlanos={handlePlanos}
                        handlePlanosCriar={handlePlanosCriar}
                        handlePlanosEdit={handlePlanosEdit}
                        handlePlanosDel={handlePlanosDel}
                        criar={planosCriar}
                        edit={planosEdit}
                        del={planosDel}
                        valor={planos}
                        cursos={curso}
                        id={id}
                      />
                    ),
                    Gerentes: (
                      <Gerentes
                        handleGerentes={handleGerentes}
                        handleGerentesCriar={handleGerentesCriar}
                        handleGerentesDel={handleGerentesDel}
                        valor={gerentes}
                        criar={gerentesCriar}
                        del={gerentesDel}
                        gestores={gestores}
                        id={id}
                      />
                    ),
                  }[valorName]
                }
              </div>
            </Segment>
            <Field>
              <Button type="submit" onClick={handleEmpresa}>
                <Icon name="save" />
                Salvar
              </Button>
              <Button type="submit" primary onClick={handleCortesia}>
                <Icon name="add" />
                Adicionar Cortesias
              </Button>
            </Field>
          </>
        )}
        </Content>
      </Container>
    </>
  );
};

export default EditarEmpresas;
